




































import Vue from 'vue'
import store from '@/store'
import actions from '@/actions'
import TextInput from '@/components/TextInput.vue'
import { Customer } from '../types'

export default Vue.extend({
  name: 'SignupCustomer',

  components: {
    TextInput,
  },

  data: () => ({
    store,
  }),

  computed: {
    customer(): Customer {
      return this.store.state.customer || {}
    },
    stepCount(): string {
      return this.store.getCurrentStepCount(
        this.store.state.signupType.key,
        String(this.$route.name),
      )
    },
  },

  methods: {
    handleInputChange(name: string, value: string) {
      this.store.setCustomer({
        ...this.customer,
        [name]: value,
      })
    },

    async submit(e: Event) {
      e.preventDefault()
      if (this.store.state.isBusy) return

      store.setIsBusy(true)
      try {
        await actions.saveCustomer()
        const nextStep = this.store.getNextStep(
          this.store.state.signupType.key,
          String(this.$route.name),
        )
        if (nextStep) {
          this.$router.push({ name: nextStep.routeName })
        }
      } catch (err) {
        this.store.setErrorMessage('Could not save info')
      } finally {
        store.setIsBusy(false)
      }
    },
  },
})
